var layout2 = "col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6";
var layout3 = "col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4";
var layout4 = "col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3";
var layout5 = "col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2";
var hideShowFiltersEvent = false;
var clearAllFilterButton = false;
let clearAllButton = document.getElementById('yv-applied-filter-cross-all');
var filters = document.getElementById('filterSideBar');
var filterContainer = document.getElementById('CollectionProductsContainer');
if(clearAllButton){
  clearAllFilterButton = true;
}

// GF FIX (okt 2026): listeners maar 1x per element koppelen.
// applyFilters() e.d. worden bij load, resize en na elke filter-render opnieuw aangeroepen;
// zonder deze check stapelden de listeners op en vuurde 1 klik meerdere fetches af.
function gfBindOnce(el, key) {
    if (!el) return false;
    var k = 'gfBound' + key;
    if (el.dataset[k]) return false;
    el.dataset[k] = '1';
    return true;
}
// GF FIX: lopend filterverzoek afbreken als er een nieuw komt, zodat alleen het laatste rendert.
var gfFilterController = null;
// GF FIX: laatst bekende vensterbreedte, zodat resize alleen iets doet als de breedte echt verandert
// (op mobiel vuurt resize ook bij het in- en uitschuiven van de adresbalk).
var gfLastWidth = window.innerWidth;
var gfResizeTimer = null;
// GF FIX: welke query-string nu op het scherm staat (voor de terugknop)
var gfRenderedSearch = window.location.search;
// GF FIX: URL toevoegen met section_id, zodat alleen de sectie wordt opgehaald i.p.v. de hele pagina.
function gfSectionUrl(href, sectionId) {
    // Relatief t.o.v. de huidige pagina (de 'Wis alles'-link is bv. '?type=product...')
    var u = new URL(href, window.location.href);
    if (sectionId) u.searchParams.set('section_id', sectionId);
    return u.pathname + u.search;
}
// GF FIX: filter-uitklappers koppelen; ook na elke filter-render (de filterkolom wordt dan vervangen).
function bindFilterTitles() {
    document.querySelectorAll('.yv-filter-title').forEach(title => {
        if (!gfBindOnce(title, 'Title')) return;
        title.addEventListener('click', function() {
            const filterContent = this.nextElementSibling;
            filterContent.classList.toggle('active');
        });
    });
}

function changeGridLayout() {
    let parent = document.getElementById('CollectionProductsContainer');
    let gridLayouts = document.querySelectorAll('.sort-grid-icon');
    Array.from(gridLayouts).forEach(function(layoutItem) {
        layoutItem.classList.remove('active');
    });
    var grid_layout_collection = Cookies.get('grid_layout_collection');
    if (parent && gridLayouts.length > 0) {
        if (window.innerWidth < 768) {
            if (grid_layout_collection && grid_layout_collection != "grid-layout-4" && grid_layout_collection != "grid-layout-5") {
                document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]').classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                document.querySelector('.sort-grid-icon[data-value="grid-layout-2"]').classList.add('active');
                parent.setAttribute("data-view", "grid-layout-2")
            }
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
            if (grid_layout_collection && grid_layout_collection != "grid-layout-4" && grid_layout_collection != "grid-layout-5") {
                document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]').classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                document.querySelector('.sort-grid-icon[data-value="grid-layout-3"]').classList.add('active');
                parent.setAttribute("data-view", "grid-layout-3")
            }
        } else if (window.innerWidth >= 992) {
            if (grid_layout_collection) {
                document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]').classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                document.querySelector('.sort-grid-icon[data-value="grid-layout-4"]').classList.add('active');
                parent.setAttribute("data-view", "grid-layout-4")
            }
        }
        updateGridView(parent);
    }
}

function hideShowFilters() {
    var filterHeading = document.getElementById('filterHeading');
    if (window.innerWidth < 768) {
        if (filterContainer && filterHeading) {
            if (filterHeading.classList.contains('filters-drawer-toggle')) {
                filterContainer.classList.add('filters-toggle');
            }
        }
    } else {
        if (filters) {
            filters.classList.remove('active')
            document.querySelector('body').classList.remove('open-filter-sort');
            document.querySelector('body').classList.remove('open-filter-popup');
        }
    }
    if (hideShowFiltersEvent == false ) {
        if (filterHeading && gfBindOnce(filterHeading, 'Heading')) {
            filterHeading.addEventListener("click", (e) => {
                e.preventDefault();
                if (window.innerWidth > 767) {
                    if (filterContainer && filterHeading) {
                        if (filterHeading.classList.contains('filters-drawer-toggle')) {
                            DOMAnimations.classToggle(filterContainer, 'filters-toggle');
                        }
                    }
                } else {
                    filters.classList.add('active')
                    document.querySelector('body').classList.add('open-filter-popup');
                    document.querySelector('body').classList.add('open-filter-sort');
                }
            });
        }
        hideShowFiltersEvent = true;
    }
}
function hideFilters(){
  var cancelFiltes = document.getElementById('cancelFilters');
  if (cancelFiltes && gfBindOnce(cancelFiltes, 'Cancel')) {
    cancelFiltes.addEventListener("click", (e) => {
      e.preventDefault();
      filters.classList.remove('active')
      document.querySelector('body').classList.remove('open-filter-popup');
      document.querySelector('body').classList.remove('open-filter-sort');
    });
  }
}
window.addEventListener('load', (event) => {
    changeGridLayout();
    hideShowFilters();
    applyFilters();
    sortByOptions();
    showMoreFilters();
    hideFilters();
  sortBy();
});

jQuery(document).on("shopify:section:load shopify:section:unload", function (event) {
    layout2 = "col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6";
    layout3 = "col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4";
    layout4 = "col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3";
    layout5 = "col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2";
    hideShowFiltersEvent = false;
    var clearAllFilterButton = false;
    let clearAllButton = document.getElementById('yv-applied-filter-cross-all');
    filters = document.getElementById('filterSideBar');
    filterContainer = document.getElementById('CollectionProductsContainer');
    if(clearAllButton){
      clearAllFilterButton = true;
    }
    changeGridLayout();
    applyFilters();
    hideShowFilters();
    sortByOptions();
    showMoreFilters();
    hideFilters();
    sortBy();
})

// GF FIX: resize gedebounced en alleen bij echte breedteverandering (niet bij alleen hoogte, zoals de adresbalk op mobiel)
window.addEventListener('resize', function(event) {
    clearTimeout(gfResizeTimer);
    gfResizeTimer = setTimeout(function() {
        if (window.innerWidth === gfLastWidth) return;
        gfLastWidth = window.innerWidth;
        changeGridLayout();
        applyFilters();
        hideShowFilters();
        sortByVisibilityChange();
        var filters = document.getElementById('filterSideBar');
        if (filters) {
            if (window.innerWidth < 768 && window.innerWidth > 760) {
                filters.style.display = 'none';
                setTimeout(function() { filters.style.display = ''; }, 500)
            }
        }
    }, 150);
});

// GF FIX: terugknop/vooruitknop na filteren. Haalt de sectie op voor de URL waar de browser naartoe gaat.
window.addEventListener('popstate', function() {
    var section = document.getElementById('CollectionProductsContainer');
    var filterForm = document.getElementById('FiltersForm');
    if (!section || !filterForm) return;
    if (window.location.search === gfRenderedSearch) return; // bv. alleen een #anker-wijziging
    getFilterData(filterForm, section.dataset.id, window.location.pathname + window.location.search, { noPush: true, noScroll: true });
});

function showMoreFilters() {
    const filterForm = document.getElementById('FiltersForm');
    if(filterForm){
        var showMoreFilters = filterForm.querySelectorAll('.filters-expand');
        if (showMoreFilters) {
            Array.from(showMoreFilters).forEach(function(showMoreFilter) {
                if (!gfBindOnce(showMoreFilter, 'More')) return;
                showMoreFilter.addEventListener("click", (e) => {
                    e.preventDefault();
                    if (showMoreFilter.classList.contains('active')) {
                        showMoreFilter.classList.remove('active');
                        DOMAnimations.slideUp(showMoreFilter.parentNode.querySelector('.more-options'), 150);
                        showMoreFilter.querySelector('span').textContent = showMoreText;
                    } else {
                        showMoreFilter.classList.add('active');
                        DOMAnimations.slideDown(showMoreFilter.parentNode.querySelector('.more-options'), 150);
                        showMoreFilter.querySelector('span').textContent = showLessText;
                    }
                });
            });
        }
    }
}

function applyFilters() {
    var section = document.getElementById('CollectionProductsContainer');
    if (section) {
        var sectionParent = section.closest('.shopify-section');
        var sectionId = section.dataset.id;
        const filterForm = document.getElementById('FiltersForm');
        if (!filterForm) {
            return false;
        }
        bindFilterTitles();
        var layouts = sectionParent.querySelectorAll('.sort-grid-icon');
        Array.from(layouts).forEach(function(layout) {
            if (!gfBindOnce(layout, 'Layout')) return;
            layout.addEventListener("click", (e) => {
                e.preventDefault();
                if (!layout.classList.contains('active')) {
                    layout.classList.add('active');
                    let allGrids = section.querySelectorAll('.aos-init');
                    Array.from(allGrids).forEach(function(grid) {
                        grid.classList.remove('aos-animate');
                        grid.classList.remove('aos-init');
                    });
                    setTimeout(function() {
                        Array.from(layouts).forEach(function(layoutItem) {
                            if (layoutItem != layout) {
                                layoutItem.classList.remove('active');
                            }
                        });
                        var _thisLayout = layout.dataset.value;
                        section.setAttribute('data-view', _thisLayout)
                        updateGridView(section);
                        var date = new Date();
                        date.setTime(date.getTime() + (parseInt(24 * 60 * 60 * 1000)));
                        Cookies.set('grid_layout_collection', _thisLayout, { expires: date, path: '/' });
                        let allImages = section.querySelectorAll('.lazyloaded');
                        Array.from(allImages).forEach(function(image) {
                            image.classList.remove('lazyloaded');
                            image.classList.add('lazyload');
                        });
                    }, 800);
                }
            });
        });

        // Prijsslider: 1x aanmaken en 1x koppelen. Desktop/mobiel wordt bepaald op het moment van schuiven.
        var priceRangeBars = filterForm.querySelectorAll('.mall-slider-handles');
        Array.from(priceRangeBars).forEach(function(rangeBar) {
            var el = rangeBar;
            if (!gfBindOnce(el, 'Slider')) return;
            var sliderEventListener = el.noUiSlider ? el.noUiSlider : noUiSlider.create(el, {
                step: 1,
                connect: true,
                start: [(parseFloat(el.dataset.start) || 0), parseFloat((el.dataset.end || el.dataset.max ))],
                range: {
                    min: [parseFloat(el.dataset.min) || 0],
                    max: [parseFloat(el.dataset.max) || 100]
                }
            });

            // Desktop en mobiel: inputs live bijwerken tijdens schuiven
            sliderEventListener.on('update', function(values) {
                var minInput = document.querySelector('input[name="filter.v.price.gte"]');
                var maxInput = document.querySelector('input[name="filter.v.price.lte"]');
                if (minInput) minInput.value = Math.round(values[0]);
                if (maxInput) maxInput.value = Math.round(values[1]);
            });

            // Alleen desktop filtert direct bij loslaten; mobiel wacht op de Toepassen-knop
            sliderEventListener.on('change', function(values) {
                if (window.innerWidth <= 767) return;
                var minRange = $(this)[0].options.range.min;
                var maxRange = $(this)[0].options.range.max;
                var minVal = parseFloat(values[0]);
                if (minVal >= minRange) {
                    section.querySelectorAll('input[name="filter.v.price.gte"]')[0].value = minVal;
                }
                var maxVal = parseFloat(values[1]);
                if (maxVal <= maxRange) {
                    section.querySelectorAll('input[name="filter.v.price.lte"]')[0].value = maxVal;
                }
                getFilterData(rangeBar, sectionId);
            });
        });

        // Checkboxes, radio's en prijsvelden: 1x koppelen (dit blok stond eerder dubbel in het bestand).
        // Desktop filtert direct, mobiel via submit van het formulier.
        var prices = filterForm.querySelectorAll('input[type=number]');
        Array.from(prices).forEach(function(price) {
            if (!gfBindOnce(price, 'Price')) return;
            price.addEventListener("change", () => {
                if (window.innerWidth > 767) {
                    getFilterData(price, sectionId)
                }
            });
        });
        var inputs = filterForm.querySelectorAll('input[type=checkbox],input[type=radio]');
        Array.from(inputs).forEach(function(input) {
            if (!gfBindOnce(input, 'Input')) return;
            input.addEventListener("click", () => {
                if (window.innerWidth > 767) {
                    getFilterData(input, sectionId)
                }
            });
        });
        if (gfBindOnce(filterForm, 'Submit')) {
            filterForm.addEventListener("submit", (e) => {
                e.preventDefault();
                getFilterData(filterForm, sectionId)
            });
        }

      var removeFilters = sectionParent.querySelectorAll('a.yv-applied-filter-remove');
        Array.from(removeFilters).forEach(function(removeFilter) {
            if(removeFilter.id == 'yv-applied-filter-cross-all' & clearAllFilterButton == false){
              return false;
            }
          else{
              if (!gfBindOnce(removeFilter, 'Remove')) return;
              removeFilter.addEventListener("click", (e) => {
                  e.preventDefault();
                  var _url = removeFilter.getAttribute('href');
                  getFilterData(removeFilter, sectionId, _url);
              });
            }
        });
    }
}



function sortByOptions() {
    var section = document.getElementById('CollectionProductsContainer');
    var sortBy = document.querySelectorAll('[name="sort_by"][data-sort-by]');
    if(section){
        var sectionId = section.dataset.id;
        Array.from(sortBy).forEach(function(sort) {
            if (!gfBindOnce(sort, 'Sort')) return;
            sort.addEventListener("change", (e) => {
                e.preventDefault();
                Array.from(sortBy).forEach(function(sort) {
                    sort.parentNode.classList.remove('selected');
                })
                sort.parentNode.classList.add('selected');
                var sortMenu = document.getElementById('sort__list');
                if(sortMenu){
                    if (sortMenu.classList.contains('active')) {
                        sortMenu.classList.remove('active');
                        if (window.innerWidth > 767) {
                            DOMAnimations.slideUp(sortMenu);
                        } else {
                            document.querySelector('body').classList.remove('open-filter-sort');
                        }
                    }
                }
                document.querySelector('body').classList.remove('open-filter-sort');
                getFilterData(sort, sectionId);
            });
        });
    }
}
function sortByVisibilityChange(){
     var sortMenu = document.querySelector('.collection-sortby-selected');
    var sortList = document.getElementById('sort__list');
    if (sortMenu && sortList) {
        if (window.innerWidth > 767) {
          if(sortList.classList.contains('active')){
            sortList.style.display = 'block';
          }else{
            sortList.style.display = 'none';
          }
          document.querySelector('body').classList.remove('open-filter-sort');
        }else{
          sortList.style.display = 'block';
          if(sortList.classList.contains('active')){
            document.querySelector('body').classList.add('open-filter-sort');
          }else{
            document.querySelector('body').classList.remove('open-filter-sort');
          }
        }
    }
}
function sortBy() {
    var sortMenu = document.querySelector('.collection-sortby-selected');
    if (sortMenu && gfBindOnce(sortMenu, 'SortMenu')) {
        sortMenu.addEventListener("click", (e) => {
            e.preventDefault();
            var sortMenu = document.getElementById('sort__list');
            if (sortMenu.classList.contains('active')) {
                sortMenu.classList.remove('active');
                if (window.innerWidth > 767) {
                    DOMAnimations.slideUp(sortMenu);
                } else {
                    document.querySelector('body').classList.remove('open-filter-sort');
                }
            } else {
                sortMenu.classList.add('active');
                if (window.innerWidth > 767) {
                    DOMAnimations.slideDown(sortMenu);
                } else {
                    document.querySelector('body').classList.add('open-filter-sort');
                }
            }
        });
    }
    var closeSortMenu = document.querySelector('.close-sort');
    if (closeSortMenu && gfBindOnce(closeSortMenu, 'SortClose')) {
        closeSortMenu.addEventListener("click", (e) => {
            e.preventDefault();
            var sortMenu = document.getElementById('sort__list');
            if (window.innerWidth < 768) {
                sortMenu.classList.remove('active');
                document.querySelector('body').classList.remove('open-filter-sort');
            }
        });
    }
}

function updateGridView(section, skipAos) {
    if (section) {
        var mainSection = document.getElementById('CollectionProductsContainer');
        var _layout = mainSection.getAttribute('data-view');
        var productItems = section.querySelectorAll('[data-product-grid]');
        if (productItems.length > 0) {
            Array.from(productItems).forEach(function(item) {
                if (_layout == 'grid-layout-2') {
                    item.setAttribute('class', layout2);
                } else if (_layout == 'grid-layout-3') {
                    item.setAttribute('class', layout3);
                } else if (_layout == 'grid-layout-4') {
                    item.setAttribute('class', layout4);
                } else if (_layout == 'grid-layout-5') {
                    item.setAttribute('class', layout5);
                }
            });
        }
        if(animationStatus && !skipAos){
          if (AOS) {
            AOS.refreshHard()
          }
        }
    }
}

function fetchFilterData(url, signal) {
    return fetch(url, { signal: signal })
        .then(response => {
            // GF FIX: bij een serverfout niet "geen resultaten" tonen; de catch hieronder laadt dan de doel-URL normaal
            if (!response.ok) {
                throw new Error('Filter request failed: ' + response.status);
            }
            return response.text();
        })
}

bindFilterTitles();

function getFilterData(input, sectionId, remove, opts) {
    opts = opts || {};
    // GF FIX: de huidige producten niet meer uit laten faden (dat gaf samen met het infaden
    // van de nieuwe producten het effect van 2x laden). Alleen een korte, rustige laadstatus.
    var gfGrid = document.querySelector('#CollectionProductsContainer [data-collection-products]');
    if (gfGrid) {
        gfGrid.style.transition = 'opacity .15s';
        gfGrid.style.opacity = '0.5';
    }
    let filterForm = document.getElementById('FiltersForm');
    const formData = new FormData(filterForm);
    // GF FIX: prijs alleen meesturen als de klant die echt heeft ingeperkt.
    // De prijsvelden staan standaard op het volledige bereik (bv. 0 en 200) en werden
    // anders bij elke filterklik meegestuurd, met een onterecht chipje "EUR 0 - 200" als gevolg.
    var gfGte = filterForm.querySelector('input[name="filter.v.price.gte"]');
    var gfLte = filterForm.querySelector('input[name="filter.v.price.lte"]');
    if (gfGte && gfLte) {
        var gfLo = parseFloat(gfGte.getAttribute('min')) || 0;
        var gfHi = parseFloat(gfLte.getAttribute('max'));
        var gfVlo = gfGte.value === '' ? gfLo : parseFloat(gfGte.value);
        var gfVhi = gfLte.value === '' ? gfHi : parseFloat(gfLte.value);
        if (isNaN(gfVlo) || gfVlo <= gfLo) formData.delete('filter.v.price.gte');
        if (isNaN(gfVhi) || (!isNaN(gfHi) && gfVhi >= gfHi)) formData.delete('filter.v.price.lte');
    }
    var searchParameters = new URLSearchParams(formData).toString();
    var clearAll = document.getElementById('yv-applied-filter-cross-all');
    var url = window.location.pathname + '?section_id=' + sectionId + '&' + searchParameters;
    var _updateUrl = window.location.pathname + '?' + searchParameters;
    if (remove) {
        // GF FIX: alleen de sectie ophalen (was: hele pagina, ~9x zo groot)
        url = gfSectionUrl(remove, sectionId);
        _updateUrl = remove;
    }
    if (gfFilterController) {
        gfFilterController.abort();
    }
    gfFilterController = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    const html = fetchFilterData(url, gfFilterController ? gfFilterController.signal : undefined).
    then((responseText) => {
        if (responseText === null) return;
        const resultData = new DOMParser().parseFromString(responseText, 'text/html');
        var itemResultCount = resultData.querySelector('.products-count');
        var sortByHtml = '';
        if (resultData.getElementById('toolbox-sort')) {
            sortByHtml = resultData.getElementById('toolbox-sort').innerHTML;
        }
        var html = resultData.getElementById('CollectionProductsContainer');
        var resultClear = resultData.getElementById('yv-applied-filter-cross-all')
        if (resultClear) {
            if (!document.getElementById('yv-applied-filter-cross-all')) {
                document.querySelector('.filter-heading-wrapper').appendChild(resultClear);
                clearAllFilterButton = true;
            }
          else{
            clearAllFilterButton = false;
          }
        }else{
            if (clearAll) {
                clearAll.remove();
                clearAllFilterButton = false;
            }
        }
        var elmnt = document.getElementById('CollectionProductsContainer');
        // GF FIX: AOS hier overslaan; de elementen staan nog niet in de pagina en AOS wordt hieronder al ververst
        updateGridView(html, true);
        if (html) {
            // GF FIX: nieuwe producten direct tonen, zonder fade-in
            html.querySelectorAll('[data-aos]').forEach(function(el) { el.removeAttribute('data-aos'); });
            elmnt.innerHTML = html.innerHTML;
        } else {
            let productResultContainer = elmnt.querySelector('[data-collection-products]');
            if (productResultContainer) {
                productResultContainer.innerHTML = noResultFound;
            }
        }
        document.querySelector('body').classList.remove('open-filter-sort');
        document.querySelector('body').classList.remove('open-filter-popup');
        filters = document.getElementById('filterSideBar');
        filterContainer = elmnt;
        let inputId = input.getAttribute('id');
        let updateInput = document.getElementById(inputId);
        if (updateInput) {
            updateInput.focus();
            let moreOption = updateInput.closest('.more-options');
            if (moreOption) {
                moreOption.style.display = 'block';
                let moreOptionText = updateInput.closest('.yv-filter-content').querySelector('.filters-expand');
                if (moreOptionText) {
                    moreOptionText.classList.add('active');
                    moreOptionText.querySelector('span').innerHTML = showLessText;
                }
            }
        }
        if (itemResultCount) {
            document.querySelector('.products-count').innerHTML = itemResultCount.innerHTML;
        }
        if (document.getElementById('toolbox-sort')) {
            document.getElementById('toolbox-sort').innerHTML = sortByHtml;
        }
        sortBy();
        applyFilters();
        showMoreFilters();
        if(filters && filters.querySelector('[name="sort_by"]')){
            sortByOptions()
        }
        hideFilters();
        if(animationStatus){
          if (AOS) {
            AOS.refreshHard()
          }
        }
        productHoverSlider();
        if (!opts.noScroll && input.getAttribute('name') != 'sort_by' && elmnt.closest('.yv-collection-container')) {
            elmnt.closest('.yv-collection-container').scrollIntoView({ behavior: "smooth" });
        }
        if (!opts.noPush) {
            history.pushState({}, null, _updateUrl);
        }
        gfRenderedSearch = window.location.search;
    }).catch((err) => {
        if (err && err.name === 'AbortError') return;
        if (gfGrid) gfGrid.style.opacity = '';
        console.error(err);
        // Terugval: gewoon de pagina met deze filters laden
        window.location.href = _updateUrl;
    });
}

let triggered = false;
function ScrollExecute() {
    if (triggered) return;
    var moreButon = $('#more').last();
    var nextUrl = moreButon.find('a').attr("href");
    if (!nextUrl) return;
    if (screenVisibility(moreButon)) {
        triggered = true;
        // GF FIX: alleen de sectie ophalen i.p.v. de hele pagina
        var container = document.getElementById('CollectionProductsContainer');
        var sectionId = container ? container.dataset.id : null;
        $.ajax({
            url: gfSectionUrl(nextUrl, sectionId),
            type: 'GET',
            beforeSend: function() {
                moreButon.find('.load').removeClass('hidden');
            }
        })
        .done(function(data) {
            var doc = new DOMParser().parseFromString(data, 'text/html');
            var newContainer = doc.getElementById('CollectionProductsContainer');
            var newProducts = newContainer ? newContainer.querySelector('[data-collection-products]') : null;
            if (!newProducts) {
                // Onverwacht antwoord: terugvallen op de gewone volgende pagina
                window.location.href = nextUrl;
                return;
            }
            moreButon.remove();
            updateGridView(newContainer, true);
            $('[data-collection-products]').append(newProducts.innerHTML);
            productVariants();
            gridPickUpAvailability();
            productHoverSlider();
            if(animationStatus){
                if (AOS) {
                AOS.refreshHard()
                }
            }
            triggered = false
        })
        // GF FIX: bij een fout niet voor altijd blokkeren
        .fail(function() {
            moreButon.find('.load').addClass('hidden');
            setTimeout(function() { triggered = false; }, 2000);
        });
    }
}
// GF FIX: scroll-handler maximaal 1x per frame laten rekenen
var gfScrollTicking = false;
$(document).ready(function() {
    window.addEventListener('scroll', function() {
        if (gfScrollTicking) return;
        gfScrollTicking = true;
        window.requestAnimationFrame(function() {
            gfScrollTicking = false;
            ScrollExecute();
        });
    }, { passive: true });
});